// @flow
import React, { Component, type ComponentType } from "react";
import RandomColor from "random-material-color";
import DateRangeIcon from "@material-ui/icons/DateRange";
import Truncate from "react-truncate";

// import PlaceIcon from "@material-ui/icons/Place";
// import CommentIcon from "@material-ui/icons/Comment";
// import FavoriteIcon from "@material-ui/icons/Favorite";
import PageViewIcon from "@material-ui/icons/Face";

import dateFormat from "../utils/localdateformat";
import { getOriginal } from "../utils/image";
import { decode } from "../utils/string";

import {
    Entry,
    Title,
    TitleText,
    TripText,
    ColorTitle,
    ColorTitleText,
    Overlay,
    DescriptionShort,
    DescriptionFull,
    Footer,
    DataCell,
    DataCellText,
    EmptyBlog,
    Actions,
    Action,
    ActionText,
    ClickableIcon,
    Icon
} from "./styled";

type Props = {|
    Photos: ComponentType<any>,
    onFetchBlog: Function,
    onShowBlog: Function,
    onFetchBlogImages: Function,
    blog: ComponentType<any>,
    fullDetail: boolean
|};

class BlogCard extends Component<Props> {
    render() {
        const { blog, fullDetail, Photos } = this.props;
        if (blog.text === undefined) {
            this.props.onFetchBlog(blog.id);
        }

        if (blog.images === undefined) {
            this.props.onFetchBlogImages(blog);
        }

        const backgroundColor = RandomColor.getColor({
            shades: ["200", "300"],
            text: blog.title
        });
        const blogHeader = blog.thumbnail ? (
            <Title
                onClick={() => this.props.onShowBlog(blog)}
                style={{
                    backgroundImage: `url(${getOriginal(blog.thumbnail)})`,
                    backgroundColor
                }}
            >
                <Overlay>
                    <TitleText>
                        {decode(blog.title)}
                        {blog.tripName && <TripText>{blog.tripName}</TripText>}
                    </TitleText>
                </Overlay>
            </Title>
        ) : (
            <ColorTitle
                onClick={() => this.props.onShowBlog(blog)}
                style={{
                    backgroundColor
                }}
            >
                <ColorTitleText>
                    {decode(blog.title)}
                    {blog.tripName && <TripText>{blog.tripName}</TripText>}
                </ColorTitleText>
            </ColorTitle>
        );

        const formattedText = blog.text ? blog.text.replace(/\n/g, "<br/>") : blog.text;

        return (
            <Entry>
                {blogHeader}
                {fullDetail ? (
                    <div>
                        <DescriptionFull>
                            {blog.text ? (
                                <div>
                                    <div dangerouslySetInnerHTML={{ __html: formattedText }} />
                                </div>
                            ) : (
                                <div>
                                    <EmptyBlog>Nothing has been written yet</EmptyBlog>
                                </div>
                            )}
                        </DescriptionFull>

                        <div style={{ marginTop: 16, marginBottom: 16 }}>
                            <Photos images={blog.images} />
                        </div>
                    </div>
                ) : (
                    blog.text && (
                        <DescriptionShort
                            onClick={() => this.props.onShowBlog(blog)}
                            onKeyPress={() => this.props.onShowBlog(blog)}
                        >
                            <Truncate
                                lines={3}
                                ellipsis={
                                    <span>
                                        ...&nbsp;
                                        <span style={{ textDecoration: "underline", opacity: 0.5 }}>
                                            see more
                                        </span>
                                    </span>
                                }
                            >
                                <div dangerouslySetInnerHTML={{ __html: blog.text }} />
                            </Truncate>
                        </DescriptionShort>
                    )
                )}

                <Footer>
                    {/*
                    <DataCell>
                        <Icon>
                            <PlaceIcon />
                        </Icon>
                        <DataCellText>Sydney, NSW, Australia</DataCellText>
                    </DataCell>
                    */}
                    <DataCell>
                        <Icon>
                            <DateRangeIcon />
                        </Icon>
                        <DataCellText>
                            {dateFormat(blog.startDate)}
                            {blog.startDate !== blog.endDate && ` -  ${dateFormat(blog.endDate)}`}
                        </DataCellText>
                    </DataCell>
                    {
                        /*
                    /*
                        <Action>
                            <ClickableIcon>
                                <CommentIcon />
                            </ClickableIcon>
                            <ClickableIcon title="100 hearts">
                                <FavoriteIcon />
                                <ActionText>100</ActionText>
                            </ClickableIcon>
                        </Action>
                        <Action>
                        </Action>

                    */
                        <Actions>
                            {blog.hits > 0 && (
                                <Action>
                                    <ClickableIcon title={`${blog.hits} views`}>
                                        <PageViewIcon />
                                        <ActionText>{blog.hits}</ActionText>
                                    </ClickableIcon>
                                </Action>
                            )}
                        </Actions>
                    }
                </Footer>
            </Entry>
        );
    }
}

export default BlogCard;



// WEBPACK FOOTER //
// ./src/blog-card/view.js